import { useTranslation } from 'react-i18next';

import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import type { HelpArticleState } from '../schemas/article-state';

const STYLES: Record<HelpArticleState, string> = {
  live: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  internal: 'bg-info/15 text-info border-transparent dark:bg-info/20',
  draft: 'border-border text-muted-foreground',
};

export interface ArticleStateBadgeProps {
  state: HelpArticleState;
  className?: string;
}

/** Live (shoppers can read it), Internal (published for staff only) or Draft. */
export function ArticleStateBadge({ state, className }: ArticleStateBadgeProps) {
  const { t } = useTranslation('helpCenter');
  return (
    <Badge
      variant="outline"
      className={cn(STYLES[state], className)}
      title={t(`stateHint.${state}`)}
    >
      {t(`state.${state}`)}
    </Badge>
  );
}
